$(window).scroll(function() {
    if (100 < $(window).scrollTop()) {
        $('.scrolltop').fadeIn('fast');
    } else {
        $('.scrolltop').fadeOut('fast');
    }
});